import styled from 'styled-components';

export const ActionWrapper = styled.div`
	display: flex;
	justify-content: center;
	gap: 20px;
	align-items: center;
`;
